<div class="ota-detail-modal">

  <!-- Modal Header -->
  <div class="modal-header">
    <h2 class="modal-title">OTA Details</h2>
    <button class="close-btn" (click)="close()">&#10005;</button>
  </div>
  <div class="header-divider"></div>

  <!-- Modal Body -->
  <div class="modal-body">

    <!-- Left Section: Execution Report -->
    <div class="left-section">
      <h3 class="section-heading">Execution Report</h3>

      <div class="current-status-block">
        <span class="status-label">Current Status</span>
        <span class="status-badge" [ngClass]="getStatusClass(executionReport.status)">
          {{ formatStatus(executionReport.status) }}
        </span>
      </div>

      <div class="execution-divider"></div>

      <div class="stats-list">
        <div class="stat-row">
          <span class="stat-label">Succeeded Things</span>
          <span class="stat-value">{{ executionReport.number_of_succeeded_things }}</span>
        </div>
        <div class="stat-row">
          <span class="stat-label">In Progress Things</span>
          <span class="stat-value">{{ executionReport.number_of_in_progress_things }}</span>
        </div>
        <div class="stat-row">
          <span class="stat-label">Failed Things</span>
          <span class="stat-value">{{ executionReport.number_of_failed_things }}</span>
        </div>
        <div class="stat-row">
          <span class="stat-label">Queued Things</span>
          <span class="stat-value">{{ executionReport.number_of_queued_things }}</span>
        </div>
        <div class="stat-row">
          <span class="stat-label">Rejected Things</span>
          <span class="stat-value">{{ executionReport.number_of_rejected_things }}</span>
        </div>
        <div class="stat-row">
          <span class="stat-label">Cancelled Things</span>
          <span class="stat-value">{{ executionReport.number_of_canceled_things }}</span>
        </div>
        <div class="stat-row">
          <span class="stat-label">Timed out Things</span>
          <span class="stat-value">{{ executionReport.number_of_timed_out_things }}</span>
        </div>
        <div class="stat-row">
          <span class="stat-label">Removed Things</span>
          <span class="stat-value">{{ executionReport.number_of_removed_things }}</span>
        </div>
      </div>
    </div>

    <!-- Vertical Divider -->
    <div class="vertical-divider"></div>

    <!-- Right Section: Details (scrollable) -->
    <div class="right-section">

      <!-- Basic Details -->
      <div class="detail-section">
        <!-- <div class="section-header" (click)="basicDetailsExpanded = !basicDetailsExpanded"> -->
        <div class="section-header">
          <h3 class="section-heading">Basic Details</h3>
          <!-- <span class="chevron" [class.expanded]="basicDetailsExpanded">&#8964;</span> -->
        </div>
        <div class="section-content" *ngIf="basicDetailsExpanded">
          <div class="basic-details-grid">
            <div class="detail-cell">
              <span class="detail-label">Job ID</span>
              <span class="detail-value">{{ job.id }}</span>
            </div>
            <div class="detail-cell">
              <span class="detail-label">Job Name</span>
              <span class="detail-value">{{ job.job_name }}</span>
            </div>
            <div class="detail-cell">
              <span class="detail-label">Model</span>
              <span class="detail-value">{{ job.model }}</span>
            </div>
            <div class="detail-cell">
              <span class="detail-label">Actual Model</span>
              <span class="detail-value">{{ job.model }}</span>
            </div>
            <div class="detail-cell">
              <span class="detail-label">Job Type</span>
              <span class="detail-value">{{ job.job_type }}</span>
            </div>
            <div class="detail-cell">
              <span class="detail-label">Upgrade Type</span>
              <span class="detail-value">{{ job.upgrade_type }}</span>
            </div>
            <div class="detail-cell">
              <span class="detail-label">Region</span>
              <span class="detail-value">{{ formatRegions(job.regions) }}</span>
            </div>
            <div class="detail-cell">
              <span class="detail-label">Created At</span>
              <span class="detail-value">{{ job.created_at | date:'MM/dd/yy, hh:mm a' }}</span>
            </div>
            <div class="detail-cell">
              <span class="detail-label">In Progress Timeout</span>
              <span class="detail-value">{{ job.inprogress_timeout_in_minutes ? job.inprogress_timeout_in_minutes + '
                minutes' : '-' }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="section-divider"></div> -->

      <!-- Wi-Fi Board Firmware -->
      <div class="detail-section">
        <div class="section-header">
          <h3 class="section-heading">Wi-Fi Board Firmware</h3>
          <!-- <span class="chevron" [class.expanded]="wifiFirmwareExpanded">&#8964;</span> -->
        </div>
        <div class="section-content" *ngIf="wifiFirmwareExpanded">
          <div class="firmware-meta-row">
            <div class="detail-cell">
              <span class="detail-label">File Name</span>
              <span class="detail-value">{{ job.wm_upgrade?.file_name ?? '-' }}</span>
            </div>
            <div class="detail-cell">
              <span class="detail-label">Firmware Version</span>
              <span class="detail-value">{{ job.wm_upgrade?.firmware_version ?? '-' }}</span>
            </div>
            <div class="detail-cell">
              <span class="detail-label">File Path On Device</span>
              <span class="detail-value">{{ job.wm_upgrade?.file_path_on_device ?? '-' }}</span>
            </div>
            <div class="detail-cell">
              <span class="detail-label">Priority</span>
              <!-- <span class="detail-value">{{ job.wm_upgrade?.priority != null ? formatPriority(job.wm_upgrade?.priority ?? 0) :
                '-' }}</span> -->
                <span class="detail-value">{{ job.wm_upgrade?.priority != null ? formatPriority(job.wm_upgrade?.priority ?? 0) : '-' }}</span>
            </div>
          </div>
          <div class="description-block">
            <span class="detail-label">Description</span>
            <p class="description-text">{{ job.wm_upgrade?.description ?? '-' }}</p>
          </div>
        </div>
      </div>

      <!-- <div class="section-divider"></div> -->

      <!-- Main Board Firmware -->
      <div class="detail-section">
        <div class="section-header">
          <h3 class="section-heading">Main Board Firmware</h3>
          <!-- <span class="chevron" [class.expanded]="mainFirmwareExpanded">&#8964;</span> -->
        </div>
        <div class="section-content" *ngIf="mainFirmwareExpanded">
          <div class="firmware-meta-row">
            <div class="detail-cell">
              <span class="detail-label">File Name</span>
              <span class="detail-value">{{ job.mb_upgrade?.file_name ?? '-' }}</span>
            </div>
            <div class="detail-cell">
              <span class="detail-label">Firmware Version</span>
              <span class="detail-value">{{ job.mb_upgrade?.firmware_version ?? '-' }}</span>
            </div>
            <div class="detail-cell">
              <span class="detail-label">File Path On Device</span>
              <span class="detail-value">{{ job.mb_upgrade?.file_path_on_device ?? '-' }}</span>
            </div>
            <div class="detail-cell">
              <span class="detail-label">Priority</span>
              <span class="detail-value">{{ job.mb_upgrade?.priority != null ? formatPriority(job.mb_upgrade?.priority
                ?? 0) : '' }}</span>
            </div>
          </div>
          <div class="description-block">
            <span class="detail-label">Description</span>
            <p class="description-text">{{ job.mb_upgrade?.description ?? '-' }}</p>
          </div>
        </div>
      </div>

      <!-- <div class="section-divider"></div> -->

      <!-- Configurations -->
      <div class="detail-section">
        <div class="section-header">
          <h3 class="section-heading">Configurations</h3>
          <!-- <span class="chevron" [class.expanded]="configurationsExpanded">&#8964;</span> -->
        </div>
        <div class="section-content" *ngIf="configurationsExpanded">
          <div class="config-grid">

            <!-- Roll Out Configuration -->
            <div class="config-column">
              <h4 class="config-column-title">Roll Out Configuration</h4>
              <div class="config-row">
                <span class="config-label">Base Rate Per Minute</span>
                <span class="config-value">{{ job.job_executions_rollout_config.exponentialRate.baseRatePerMinute
                  }}</span>
              </div>
              <div class="config-row">
                <span class="config-label">Increment Factor</span>
                <span class="config-value">{{ job.job_executions_rollout_config.exponentialRate.incrementFactor
                  }}</span>
              </div>
              <div class="config-row">
                <span class="config-label">Number of Succeeded Things</span>
                <span class="config-value">{{
                  job.job_executions_rollout_config.exponentialRate.rateIncreaseCriteria.numberOfSucceededThings
                  }}</span>
              </div>
              <div class="config-row">
                <span class="config-label">Maximum Per Minute</span>
                <span class="config-value">{{ job.job_executions_rollout_config.maximumPerMinute }}</span>
              </div>
            </div>

            <!-- Abort Configuration 1 -->
            <div class="config-column">
              <h4 class="config-column-title">Abort Configuration 1</h4>
              <ng-container *ngIf="getAbortCriteria(0) as criteria; else noAbort1">
                <div class="config-row">
                  <span class="config-label">Action</span>
                  <span class="config-value">{{ criteria.action }}</span>
                </div>
                <div class="config-row">
                  <span class="config-label">Failure Type</span>
                  <span class="config-value">{{ criteria.failureType }}</span>
                </div>
                <div class="config-row">
                  <span class="config-label">Min Number Of Executed Things</span>
                  <span class="config-value">{{ criteria.minNumberOfExecutedThings }}</span>
                </div>
                <div class="config-row">
                  <span class="config-label">Threshold Percentage</span>
                  <span class="config-value">{{ criteria.thresholdPercentage }}</span>
                </div>
              </ng-container>
              <ng-template #noAbort1>
                <span class="config-value">-</span>
              </ng-template>
            </div>

            <!-- Abort Configuration 2 -->
            <div class="config-column">
              <h4 class="config-column-title">Abort Configuration 2</h4>
              <ng-container *ngIf="getAbortCriteria(1) as criteria; else noAbort2">
                <div class="config-row">
                  <span class="config-label">Action</span>
                  <span class="config-value">{{ criteria.action }}</span>
                </div>
                <div class="config-row">
                  <span class="config-label">Failure Type</span>
                  <span class="config-value">{{ criteria.failureType }}</span>
                </div>
                <div class="config-row">
                  <span class="config-label">Min Number Of Executed Things</span>
                  <span class="config-value">{{ criteria.minNumberOfExecutedThings }}</span>
                </div>
                <div class="config-row">
                  <span class="config-label">Threshold Percentage</span>
                  <span class="config-value">{{ criteria.thresholdPercentage }}</span>
                </div>
              </ng-container>
              <ng-template #noAbort2>
                <span class="config-value">-</span>
              </ng-template>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>

  <!-- Modal Footer -->
  <div class="modal-footer">
    <button class="action-btn" [class.delete-btn]="isCancelledJob" [disabled]="isActionInProgress" (click)="onActionButton()">
      <span class="btn-content" *ngIf="!isActionInProgress">
        {{ isCancelledJob ? 'Delete' : 'Cancel' }}
      </span>
      <span class="btn-content" *ngIf="isActionInProgress">
        <span class="btn-spinner" aria-hidden="true"></span>
        {{ isCancelledJob ? 'Deleting...' : 'Cancelling...' }}
      </span>
    </button>
  </div>

</div>